import gql from 'graphql-tag'
import Notification from '~/models/notification'

export interface FindNotificationResponse {
  notification: Notification
}

export const FIND_NOTIFICATION = gql`
  query Notification {
    notification (
      id: 1
    ) {
      id
      message
      link
    }
  }
`